import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

// Components
import Spinner from '../Spinner';

const propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

const PublicRoute = ({
  component: Component,
  restricted,
  layout: Layout,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props =>
        restricted ? (
          <Redirect to="/" />
        ) : (
          <Suspense fallback={<Spinner size="small" flow="block" />}>
            <Component {...props} />
          </Suspense>
        )
      }
    />
  );
};

PublicRoute.propTypes = propTypes;

export default PublicRoute;
